import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/shadows.stylex';
import { shadows } from '@tokens/shadows.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Ported 1:1 from the prototype `.seg` (segmented control) + `.seg2` (full-width, accent-active).
export const styles = {
  seg: {
    k1xSpc: "x3nfvp2",
    kOIVth: "x1ed6fcf",
    kmVPX3: "x9ms5i6",
    kWkggS: "xvys5x3",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kaIpWk: "xxltkoq",
    $$css: true
  },
  segBlock: {
    k1xSpc: "x78zum5",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  btn: {
    kmVPX3: "xasb0xz",
    kaIpWk: "xu4hgxq",
    ksu8eU: "xng3xce",
    kWkggS: "xjbqb8w",
    kMv6JI: "xdv2sak",
    kGuDYH: "x4z9k3i",
    k63SB2: "xomqrzn",
    kMwMTN: "xdxw5r1",
    kkrTdU: "x1ypdohk",
    khDVqt: "xuxw1ft",
    kmkexE: "x1k3q35m",
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    $$css: true
  },
  btnBlock: {
    kUk6DE: "x98rzlu",
    kmVPX3: "xskserf",
    k9WMMc: "x2b8uid",
    $$css: true
  },
  btnActive: {
    kWkggS: "x1k55akt",
    kMwMTN: "x1oezkus",
    kGVxlE: "x7g3v46",
    $$css: true
  },
  btnActiveAccent: {
    kWkggS: "x1k55akt",
    kMwMTN: "x1459q0w",
    kGVxlE: "x7g3v46",
    $$css: true
  }
};